import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { getCompanyHubSpaceKey } from '@confluence/route-manager/entry-points/companyHubUtils.ts';

import type {
	CompanyHubSpaceQuery as CompanyHubSpaceQueryType,
	CompanyHubSpaceQueryVariables,
} from './__types__/CompanyHubSpaceQuery.ts';
import { CompanyHubSpaceQuery } from './CompanyHubSpaceQuery.graphql.ts';
// oxlint-disable-next-line graphql-relay-compat/no-interop-imports -- see https://go.atlassian.com/cfe-no-interop-imports
import { queryInterop } from '@confluence/apollo-relay-interop/entry-points/query.ts';

export async function checkIfCompanyHubSpaceExists(): Promise<boolean> {
	const key = getCompanyHubSpaceKey();
	if (!key) {
		throw new Error('Failed to get company hub space key');
	}

	try {
		const { data } = await queryInterop<CompanyHubSpaceQueryType, CompanyHubSpaceQueryVariables>({
			query: CompanyHubSpaceQuery,
			variables: { key },
		});
		return !!data?.space?.id;
	} catch (error) {
		if (error?.message.includes('NotFoundException')) {
			markErrorAsHandled(error);
			return false;
		} else {
			throw error;
		}
	}
}
